import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FontResizerComponent } from '@frontend/sports/common/core/feature/font-resizer';
import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { NativePriceFormatterPipe } from '@frontend/sports/odds/feature/native-price';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';
import { EffectsModule } from '@ngrx/effects';
import { AccaBoostBaseModule } from 'packages/sports/web/app/src/acca-boost-base/acca-boost-base.module';
import { ArcModule } from 'packages/sports/web/app/src/arc/arc.module';
import { EventPickComponent } from 'packages/sports/web/app/src/option-pick/event-pick.component';
import { TimerModule } from 'packages/sports/web/app/src/timers/timer.module';

import BetslipDigitalBetGenerationModule from '../bet-generation/betslip-digital-bet-generation.module';
import { UpsellContainerComponent } from './components/upsell-container.component';
import { UpsellItemComponent } from './components/upsell-item.component';
import { UpsellWinningsComponent } from './components/upsell-winnings.component';
import { UpsellBetTypeService } from './services/upsell-bet-type.service';
import { UpsellDataService } from './services/upsell-data.service';
import { UpsellEventFactoryService } from './services/upsell-event-factory.service';
import { UpsellOverridesService } from './services/upsell-overrides.service';
import { UpsellPushService } from './services/upsell-push.service';
import { UpsellSettingsService } from './services/upsell-settings.service';
import { UpsellSummaryService } from './services/upsell-summary.service';
import { UpsellVisibilityService } from './services/upsell-visibility.service';
import { UpsellWinningsService } from './services/upsell-winnings.service';
import UpsellTrackingEffects from './state/upsell-tracking.effects';

@NgModule({
    providers: [
        UpsellDataService,
        UpsellVisibilityService,
        UpsellSettingsService,
        UpsellEventFactoryService,
        UpsellWinningsService,
        UpsellPushService,
        UpsellBetTypeService,
        UpsellOverridesService,
        UpsellSummaryService,
    ],
    declarations: [UpsellContainerComponent, UpsellItemComponent, UpsellWinningsComponent],
    exports: [UpsellContainerComponent],
    imports: [
        EventPickComponent,
        TimerModule,
        ParticipantImageComponent,
        CommonModule,
        ArcModule,
        BetslipDigitalBetGenerationModule,
        AccaBoostBaseModule,
        EffectsModule.forFeature([UpsellTrackingEffects]),
        FontResizerComponent,
        ScrollAdapterComponent,
        NativePriceFormatterPipe,
    ],
})
export class BetslipDigitalUpsellModule {}
